import Card from '@components/Card';
import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import EditIcon from '@icons/edit/EditFill';
import TrashIcon from '@icons/TrashFill';
import { useAtom, useAtomValue } from 'jotai';

import HandleIcon from './HandleIcon';
import img from './img.png';
import { deleteMyMenuIdsAtom, isDeletingAtom } from '../../atoms/myMenuAtoms';

interface Props {
    id: string;
}

function MyMenuItem({ id }:Props) {
    const isDeleting = useAtomValue(isDeletingAtom);
    const [deleteIds, setDeleteIds] = useAtom(deleteMyMenuIdsAtom);
    const isChecked = deleteIds.includes(id);
    const toggleCheckbox = () => {
        if (isChecked) {
            setDeleteIds(deleteIds.filter((deleteId) => deleteId !== id));
        } else {
            setDeleteIds([...deleteIds, id]);
        }
    };
    return (
        <Row spacing={4}>
            {isDeleting && (
                <Checkbox toggleCheckbox={toggleCheckbox} />
            )}
            <ItemCard>
                <Card.Body>
                    <Row spacing={1} fullWidth>
                        <Image src={img} alt='myMenu'
                            width={76}
                            height={76} />
                        <Column fullWidth>
                            <HandleRow justify='flex-end' fullWidth>
                                <HandleIcon/>
                            </HandleRow>
                            <Text size='title-lg' fontWeight='bold'>겨울에도 얼죽아 화이팅</Text>
                            <NameText color={colors.gray6} fontWeight='bold'>
                                아이스 아메이카노
                            </NameText>
                            <Option>
                                ICEㅣ일회용컵 사용ㅣL사이즈ㅣ샷추가(+500)ㅣ카라멜마끼아또 시럽추가(+500)ㅣ설탕 시럽추가(+500)
                            </Option>
                        </Column>
                    </Row>
                </Card.Body>
                <Card.Footer>
                    <Row fullWidth justify='flex-end' spacing={2.5}>
                        <Row>
                            <EditIcon size={24}
                                color='#6E6864'/>
                            <Text color={colors.gray7}>이름 변경</Text>
                        </Row>
                        <Row>
                            <TrashIcon size={24}
                                color='#6E6864'/>
                            <Text color={colors.gray7}>삭제</Text>
                        </Row>
                    </Row>
                </Card.Footer>
            </ItemCard>
        </Row>
    );
}

const ItemCard = styled(Card)`
    flex: 1;
`;

const HandleRow = styled(Row)`
    padding: 6px 2px 14px 0;
`;

const NameText = styled(Text)`
    margin: 12px 0 4px;
`;

const Option = styled.div`
    font-size: 12px;
    line-height: 1.4;
    color: var(--color-gray6);
`;

export default MyMenuItem;
